import React, { useRef } from 'react';
import EventsBodyView from './components/body/EventsBodyView';
import { CATEGORIES } from './constants';
import { SubsectionHeader } from '@/presentation/reusables/SectionHeader';
import ModuleContainer from '@/presentation/components/Container';

interface EventProps {
  handleTab: (selected: number) => void;
  selectEvent: (eventId: number, typeEvent: string) => void;
  goBackButton: () => void;
  subsectionHeader: any;
}

const EventsView = (props: EventProps) => {
  const { handleTab, selectEvent, goBackButton, subsectionHeader } = props;
  const scrollContainer: React.MutableRefObject<any> = useRef(null);
  return (
    <ModuleContainer containerType="subsection">
      <SubsectionHeader
        title={subsectionHeader[0].title}
        onClick={goBackButton}
      />
      <div className="fixedWidth">
        <EventsBodyView
          categories={CATEGORIES}
          handleTab={handleTab}
          selectEvent={selectEvent}
          scrollContainer={scrollContainer}
        />
      </div>
    </ModuleContainer>
  );
};

export default EventsView;
